import { UniqueId } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';
const Cookies = require('js-cookie');

export default class AhoyTracker {
  constructor(element, propsCustom = {}) {
    this.element = element;
    this.title   = element.dataset.ahoyTitle;
    this.props   = element.dataset.ahoyProps;
    this.propsImpression = element.dataset.ahoyImpressionProps;
    this.propsClick = element.dataset.ahoyClickProps;
    this.propsCustom = propsCustom;
    this.data = element.dataset;
    this.impressionSent = false;
  }

  init() {
    if (this.data.ahoyloaded == undefined && this.title != undefined) {
      this.data.ahoyloaded = 'true';

      this.setSearchUUID();

      if(this.data.ahoySend != undefined) {
        this.sendEvent();
      }
      if(this.data.ahoyClick != undefined) {
        this.bindClick();
      }
      if(this.data.ahoyImpression != undefined) {
        this.bindImpression();
      }
    }
  }

  static getEventTitle(titleParam){
    var title = titleParam ? titleParam : 'UNTITLED';
    return 'VIDIO::' + title.toUpperCase();
  }

  setSearchUUID(){
    if (this.title.toLowerCase() == 'search') {
      var props = JSON.parse(this.props);
      var search_uuid = Cookies.get('search_uuid');
      props.search_uuid = search_uuid == undefined ? UniqueId.get() : search_uuid;
      this.props = JSON.stringify(props);
    }
  }

  static getEventProps(ahoyProps, customProps = null, addProps = null){
    try {
      const ahoyPropsObject = JSON.parse(ahoyProps);
      const props = Object.assign(ahoyPropsObject, customProps);

      if(addProps) {
        addProps = JSON.parse(addProps);
        return Object.assign(props, addProps);
      }
      return props;
    } catch(e) {
      return null;
    }
  }

  sendEvent(props){
    if ("useDynamicProps" in this.element.dataset) {
      this.props = this.element.dataset.ahoyProps
    }

    var eventTitle = AhoyTracker.getEventTitle(this.title);
    var eventProps = AhoyTracker.getEventProps(this.props, this.propsCustom, props)
    AhoyTracker._sendEvent(eventTitle, eventProps);
  }

  sendEventImpression(){
    if(!this.impressionSent && this.inViewPort()) {
      this.impressionSent = true;
      this.sendEvent(this.propsImpression);
    }
  }

  sendEventClick(){
    if(this.props && this.props.includes('"feature":"typo_suggestion"')) {
      Cookies.set('search_uuid', UniqueId.get());
    }else{
      this.sendEvent(this.propsClick);
    }
  }

  static _sendEvent(title, props){
    if(title && props) {
      AhoyEvent.send(title, props);
    }
  }

  bindClick() {
    var posX = 0;

    this.element.addEventListener('mousedown', function(event) {
      posX = event.clientX;
    }.bind(this));

    this.element.addEventListener('mouseup', function(event) {
      posX -= event.clientX || 0;
      if(posX == 0) {
        this.sendEventClick();
      }
    }.bind(this));
  }

  bindImpression() {
    var parentNode = this.element.parentNode;
    if(this.isReadyStateComplete()) {
      this.sendEventImpression();
    } else {
      window.addEventListener('load', this.sendEventImpression.bind(this));
    }

    window.addEventListener('scroll', this.sendEventImpression.bind(this));
    if(parentNode.scrollWidth > parentNode.clientWidth) {
      parentNode.addEventListener('scroll', this.sendEventImpression.bind(this));
    }
  }

  isReadyStateComplete() {
    return document.readyState == 'complete';
  }

  inViewPort(){
    if("useBoundingClientRect" in this.element.dataset) {
      return AhoyTracker.inBoundRectViewPort(this.element);
    } else {
      return ViewPort.isInView(window, this.element);
    }
  }

  static inBoundRectViewPort(element){
    const MINIMUM_VIEWABLE_ELEMENT = 10;

    var rect = element.getBoundingClientRect();
    var width = document.documentElement.clientWidth;
    var height = document.documentElement.clientHeight;
    if(rect.height == 0) {
      return false;
    }

    return (!!rect && rect.bottom >= 0 && rect.top + MINIMUM_VIEWABLE_ELEMENT <= height && rect.right >= 0 && rect.left <= width);
  }
}

export class ViewPort {
  static isInView(windowObj, element) {
    var scrollPos = window.scrollY;
    var bottomPos = scrollPos + window.innerHeight;
    var elementTopPos = element.offsetTop;
    var elementBottomPos = element.offsetTop + element.offsetHeight;

    return (bottomPos > elementTopPos && elementTopPos > scrollPos) ||
      (bottomPos > elementBottomPos && elementBottomPos > scrollPos) ||
      (scrollPos > elementTopPos && bottomPos < elementBottomPos);
  }
}
